import {request} from './client.js'

/**
 * Trigger the backend self-update sequence (admin only). The server discards
 * local changes, pulls the latest revision, and restarts the process, then
 * responds with `{ok: 1, output}`. On failure it responds with HTTP 500 and
 * `{error}`, which surfaces as an {@link import('./client.js').ApiError} whose
 * `message` is the reported subprocess diagnostic.
 * @return {Promise<{ok: number, output: string}>}
 */
export function upgradeBackend() {
    return request('POST', '/upgrade-backend', {
        // the upgrade spawns git + pm2 restart server-side; give it generous
        // headroom rather than the default fetch timeout
        signal: AbortSignal.timeout(60_000)
    })
}
